import React from 'react';
import { pick } from 'lodash';
import { feeSchedulePrograms as fspUtils } from '@unite-us/client-utils';
import ShortDates from 'common/utils/Dates/ShortDates';
import formatSpend from 'common/utils/Money/formatSpend';
import {
  AUTHORIZATION_STATUSES,
  AUTHORIZATION_STATUSES_TO_ICON,
  AUTHORIZATION_STATUSES_TO_COLOR,
} from 'common/Status/authorizationConstants';

export const formatAmount = (authorization) => {
  const isCostBased = fspUtils.isCostPaymentType(authorization.fee_schedule_program?.payment_type);
  const amount = isCostBased ?
    (authorization.approved_cents || authorization.requested_cents) :
    (authorization.approved_unit_amount || authorization.requested_unit_amount);

  const unit = authorization.fee_schedule_program?.unit || 'unit';
  return formatSpend(amount, unit, isCostBased);
};

export const formatDates = (authorization) => {
  const startsAt = authorization.approved_starts_at || authorization.requested_starts_at;
  const endsAt = authorization.approved_ends_at || authorization.requested_ends_at;

  return <ShortDates startDate={startsAt} endDate={endsAt} />;
};

export const isUnilaterallyUpdatedAuthorization = (authorization) => (
  authorization.requester.id === authorization.adjudicator?.id
);

export const authorizationHistoryIcon = pick(
  AUTHORIZATION_STATUSES_TO_ICON,
  [
    AUTHORIZATION_STATUSES.accepted,
    AUTHORIZATION_STATUSES.rejected,
    AUTHORIZATION_STATUSES.void,
  ],
);

export const authorizationHistoryIconColor = {
  ...AUTHORIZATION_STATUSES_TO_COLOR,
  [AUTHORIZATION_STATUSES.void]: 'var(--color-text-blue)',
};
